import { useState } from "react";
import {
  Typography,
  Stack,
  Button,
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { ReactComponent as IconDiamond } from "../../images/icon-diamond.svg";
import { ReactComponent as IconWallet } from "../../images/iconWallet.svg";
import { escalaFuncionalList } from "../RegistrarEscalaPaciente/dataInitialPaciente";
import { useParams, useLocation, Link } from "react-router-dom";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import ModalDialogs from "../../components/ModalDialogs/index";
import { useNavigate } from "react-router-dom";
import { requestEscalaALS } from "../../services/cadastroService";

export const styles = {
  title: {
    fontSize: "20px",
    lineHeight: "27px",
    marginBottom: "1rem",
    color: "#1E729F",
    fontWeight: "500",
  },
  subtitle: {
    fontSize: "16px",
    lineHeight: "22px",
    marginBottom: "16px",
    color: "#063F5E",
    fontWeight: "700",
  },
  container: {
    boxShadow: "0px 1px 8px 0px #00000026",
    padding: "16px",
    gap: "16px",
    borderRadius: "12px",
    marginBottom: "16px",
  },
};

export default function RegistrarEscalaPaciente() {
  const navigate = useNavigate();
  const location = useLocation();

  const { id } = useParams();
  const [values, setValue] = useState({
    a: undefined,
    b: undefined,
    c: undefined,
    d: undefined,
    e: undefined,
    e1: undefined,
    f: undefined,
    g: undefined,
    h: undefined,
    i: undefined,
    j: undefined,
    k: undefined,
    l: undefined,
  });
  const [valueTotal, setValueTotal] = useState(0);
  const [subescalaBulbar, setSubescalaBulbar] = useState(0);
  const [subescalaMotorFino, setSubescalaMotorFino] = useState(0);
  const [subescalaTronco, setSubescalaTronco] = useState(0);
  const [subescalaRespiratoria, setSubescalaRespiratoria] = useState(0);
  const [formSaved, setFormSaved] = useState(false);

  const [dataModal, setDataModal] = useState({
    open: false,
    onClose: () => {},
    onActionPrimary: () => {},
    onActionSecondary: () => {},
    modalType: "success",
    title: "",
    body: "",
    secondaryButtonText: "",
    primaryButtonText: "",
  });

  const handleClose = () => {
    setDataModal((oldValue) => ({ ...oldValue, open: false }));
  };

  function handleNavigate() {
    navigate(`/paciente/escalaspaciente/`);
  }

  function prepararDados() {
    const dados = {
      idVinculo: null,
      idConsulta: null,
      idPaciente: id,
      subescalaBulbar: subescalaBulbar,
      subescalaMotorFino: subescalaMotorFino,
      subescalaTronco: subescalaTronco,
      subescalaRespiratoria: subescalaRespiratoria,
      total: valueTotal,
      respostas: {
        ...values,
        e1: values.e === 4 ? values.e1 : null,
        e2: values.e === 3 ? values.e1 : null,
      },
    };

    return dados;
  }

  async function handleSubmit(event) {
    event?.preventDefault();
    handleClose();

    const dados = prepararDados();

    try {
      const response = await requestEscalaALS(dados);

      if (response.hasOwnProperty("error")) {
        throw new Error(response.message);
      }

      setFormSaved(true);
      setDataModal({
        open: true,
        onClose: () => handleClose(),
        onActionPrimary: () => handleNavigate(),
        onActionSecondary: () => {},
        modalType: "success",
        title: "Dados salvos",
        body: `O resultado da escala funcional é ${valueTotal}. Resultado salvo com sucesso!`,
        secondaryButtonText: "",
        primaryButtonText: "Ir para Escalas",
      });
    } catch (error) {
      console.error(error);
      setFormSaved(false);
    }
  }

  function handleSetValue(field, value) {
    setValue((oldValue) => ({
      ...oldValue,
      [field]: value,
    }));
  }
  // verficicando se todos os campos foram preenchido
  const allValuesDefined = Object.values(values).every(
    (value) => value !== undefined
  );

  function calcularTotal() {
    if (allValuesDefined) {
      // Calcula a soma de todos os valores, exceto o valor associado à chave "e"
      const valorTotal = Object.keys(values).reduce((acc, key) => {
        if (key !== "e") {
          return acc + values[key];
        }
        return acc;
      }, 0);
      setFormSaved(false);
      setValueTotal(valorTotal);
      setSubescalaBulbar(Number(values.a + values.b + values.c));
      setSubescalaMotorFino(Number(values.d + values.e1 + values.f));
      setSubescalaTronco(Number(values.g + values.h + values.i));
      setSubescalaRespiratoria(Number(values.j + values.k + values.l));
      // localStorage.setItem("novaEscalaFuncional", valorTotal);
    } else {
      return;
    }
  }

  const RenderItem = ({ field, data }) => (
    <Box key={field} sx={styles.container}>
      <Stack direction="row">
        <Typography sx={styles.subtitle}>{data.label}</Typography>
        <IconDiamond fill="#FC8518" />
      </Stack>
      <RadioGroup
        sx={{
          display: "flex",
          flexDirection: "column",
          color: "#333333",
          justifyContent: "center",
        }}
        onChange={(e) => handleSetValue(field, Number(e.target.value))}
      >
        {data.options.map((op) => (
          <FormControlLabel
            key={op.label}
            control={
              <Radio required sx={{ pt: 0.5, pb: 0.5, color: "#1E729F" }} />
            }
            checked={values[field] === op.value}
            label={op.label}
            value={op.value}
          />
        ))}
      </RadioGroup>
    </Box>
  );

  function handleGoBack() {
    if (formSaved && valueTotal !== 0) {
      handleNavigate();
    } else if (valueTotal !== 0) {
      setDataModal({
        open: true,
        onClose: () => handleClose(),
        onActionPrimary: () => handleSubmit(),
        onActionSecondary: () => handleNavigate(),
        modalType: "warning",
        title: "Dados não salvos",
        body: "Você deseja salvar o resultado da Escala Funcional?",
        secondaryButtonText: "Não",
        primaryButtonText: "Sim",
      });
    } else {
      handleNavigate();
    }
  }

  return (
    <Box>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <ButtonGoBack onClick={handleGoBack} />

        <Typography style={styles.title}>
          ALS Functional Rating Scale
        </Typography>
        <div>
          {escalaFuncionalList &&
            Object.entries(escalaFuncionalList).map(([field, data]) => {
              const e1Label = escalaFuncionalList.e1.label;
              const e2Label = escalaFuncionalList.e2.label;
              if (e1Label === data.label && values.e === 4) {
                return <RenderItem key={"e1"} field={"e1"} data={data} />;
              } else if (e2Label === data.label && values.e === 3) {
                return <RenderItem key={"e1"} field={"e1"} data={data} />;
              } else if (e1Label !== data.label && e2Label !== data.label) {
                return <RenderItem key={field} field={field} data={data} />;
              }
            })}
        </div>

        <Button
          variant="contained"
          type={allValuesDefined ? "button" : "submit"}
          sx={{ textTransform: "none", mb: 2, mt: 2, fontSize: "1rem" }}
          onClick={() => calcularTotal()}
          color="primary"
        >
          Calcular
        </Button>

        <Typography sx={{ ...styles.subtitle, fontSize: "18px" }}>
          Valor total da escala
        </Typography>
        <TextField type="number" disabled value={valueTotal} sx={{ mb: 2 }} />

        <div style={{ display: "flex", gap: "8px" }}>
          <Box>
            <Button
              type="submit"
              variant="contained"
              sx={{ textTransform: "none", mb: 4, fontSize: "1rem" }}
              color="primary"
            >
              Salvar
            </Button>
          </Box>
          <Box>
            {allValuesDefined ? (
              <Button
                onClick={() => handleGoBack()}
                variant="contained"
                sx={{ textTransform: "none", mb: 4, fontSize: "1rem" }}
                color="primary"
              >
                Voltar
              </Button>
            ) : (
              <Link to="/paciente/escalaspaciente/">
                <Button
                  variant="contained"
                  sx={{ textTransform: "none", mb: 4, fontSize: "1rem" }}
                  color="primary"
                >
                  Voltar
                </Button>
              </Link>
            )}
          </Box>
        </div>
      </form>
      <ModalDialogs
        open={dataModal.open}
        onClose={dataModal.onClose}
        modalType={dataModal.modalType}
        maxWidth="750px"
        title={
          <>
            <IconWallet /> {dataModal.title}
          </>
        }
        body={
          <Box sx={{ width: { sx: "100%", sm: "400px " } }}>
            {dataModal.body}
          </Box>
        }
        onActionPrimary={dataModal.onActionPrimary}
        primaryButtonText={dataModal.primaryButtonText}
        onActionSecondary={dataModal.onActionSecondary}
        secondaryButtonText={dataModal.secondaryButtonText}
      />
    </Box>
  );
}
